import Vue from 'vue'
import LiquorTree from 'liquor-tree'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(LiquorTree.name, LiquorTree)
